import { noop } from "lodash";
import { createContext, useContext } from "react";

export const ToggleContext = createContext({
    isOpen: false,
    onToggle: noop
})

export const useToggleContext = () => useContext(ToggleContext)